module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-foobars-list"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('loading-spinner')], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foobars.length === 0 && !_vm.loading),
      expression: "foobars.length === 0 && !loading"
    }],
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.text.no_foobars')) + "\n      ")])], 1), _vm._v(" "), _vm._l((_vm.foobars), function(fb) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.foobars.length > 0),
        expression: "foobars.length > 0"
      }],
      staticClass: "row"
    }, [_c('clearfix', {
      attrs: {
        "wide": true
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 content fb-bg-light"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.$store.state.auth.editor),
        expression: "$store.state.auth.editor"
      }],
      staticClass: "foobar-edit-menu"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (fb.status === 'NEWS' || fb.status === 'AVAILABLE'),
        expression: "fb.status === 'NEWS' || fb.status === 'AVAILABLE'"
      }],
      attrs: {
        "title": _vm.$t('message.icon.title.news_status_' + fb.status)
      },
      on: {
        "click": function($event) {
          _vm.updateStatus(fb.id, (fb.status === 'NEWS' ? 'AVAILABLE' : 'NEWS'))
        }
      }
    }, [_c('icon', {
      class: 'is-enabled-' + (fb.status === 'NEWS'),
      attrs: {
        "name": "beer"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (fb.status === 'NEWS' || fb.status === 'AVAILABLE'),
        expression: "fb.status === 'NEWS' || fb.status === 'AVAILABLE'"
      }],
      attrs: {
        "title": _vm.$t('message.icon.title.hide')
      },
      on: {
        "click": function($event) {
          return _vm.updateStatus(fb.id, 'HIDDEN')
        }
      }
    }, [_c('icon', {
      staticClass: "is-enabled-true",
      attrs: {
        "name": "eye"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (fb.status !== 'NEWS' && fb.status !== 'AVAILABLE'),
        expression: "fb.status !== 'NEWS' && fb.status !== 'AVAILABLE'"
      }],
      attrs: {
        "title": _vm.$t('message.icon.title.show')
      },
      on: {
        "click": function($event) {
          return _vm.updateStatus(fb.id, 'AVAILABLE')
        }
      }
    }, [_c('icon', {
      staticClass: "is-enabled-false",
      attrs: {
        "name": "eye-slash"
      }
    })], 1), _vm._v(" "), _c('span', {
      attrs: {
        "title": _vm.$t('message.icon.title.edit')
      },
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'FoobarEditor',
            params: {
              id: fb.id
            }
          })
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "pencil"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (fb.status !== 'DELETED'),
        expression: "fb.status !== 'DELETED'"
      }],
      attrs: {
        "title": _vm.$t('message.icon.title.delete')
      },
      on: {
        "click": function($event) {
          return _vm.updateStatus(fb.id, 'DELETED')
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash"
      }
    })], 1)]), _vm._v(" "), _c('h4', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Foobar',
          params: {
            id: fb.id
          }
        }
      }
    }, [_vm._v(_vm._s(fb.title))])], 1), _vm._v(" "), _c('div', {
      staticClass: "foobar-description",
      domProps: {
        "innerHTML": _vm._s(fb.description)
      }
    })])], 1)
  }), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f692a28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/foobar/FoobarList.vue
// module id = 1831
// module chunks = 1